import { EmptyListStyled } from './EmptyList.styled';
import { FC } from 'react';
import { EmptyListProps } from './EmptyList.types';

export const EmptyList : FC<EmptyListProps> = ({ children }) => <EmptyListStyled>{children}</EmptyListStyled>